<div class="cell flex-column align-items-start">
  <div class="d-flex align-items-center">
    <div class="cell_number" [matTooltip]="params.data[props.numberProp]">
      {{ !props?.dollarProp ? params.data[props.numberProp]  !== null ? (params.data[props.numberProp] | number: "1.0-2" ): 'N/A' : (params.data[props.numberProp] | currency ) }}
    </div>
    <div class="cell_trend ms-1">
      <i class="fas fa-arrow-up" *ngIf="trend === 'up'" [matTooltip]="!props?.dollarProp ? 'Sales has recently increased' : ''"></i>
      <i class="fas fa-arrow-down" *ngIf="trend === 'down'" [matTooltip]="!props?.dollarProp ? 'Sales has recently decreased' : ''"></i>
    </div>
  </div>
  <div class="cell_row">
    <div class="cell_number"  [ngClass]="isApplied ? 'suggested-count--added': showSeasonal ? 'primary' :'gray'" 
    *ngIf="(isShowYearlyTrend) && (Velocity90_1yr ||  PctChange1Yr)"  (click)="addAmountToShipment(Velocity90_1yr)"> 
     <span *ngIf="!params.data.AccountSkuId || (params.data.AccountSkuId && Velocity90_1yr > 0 && showSeasonal)" [matTooltip]="'Click to apply the seasonal velocity'"  class="cell_link">Seasonal velocity: <span class="value">{{Velocity90_1yr}}</span></span>
     <span *ngIf="params.data.AccountSkuId  && !showSeasonal && PctChange1Yr !== 0">Seasonal: <span class="value">{{PctChange1Yr | number: "1.0-2"}}%</span></span>    
    </div>
   <div *ngIf="props.showPurchaseVelocity && ((Velocity90_1yr > 0 && showSeasonal) || (!showSeasonal && PctChange1Yr !== 0))" class="item item--clickable"
       (click)="openExpandDialog($event)"><i class="fas fa-chevron-down"></i>
   </div>
  </div>  
</div>